/* Yips product page + 3-pack bundle builder.
   - No discount logic: the store's automatic Buy 2 Get 1 Free (cheapest item free) and the
     auto-added free gifts are applied in the cart. Prices shown here are previews.
   - One POST /cart/add.js with an items array, then refresh the Upcart drawer (fallbacks below).
   - Cart-aware (only when the 3-pack builder is on): reads /cart.js on load and after any cart
     change (incl. Upcart drawer edits) and counts hats already in the cart, so the 3-pack box,
     tiles, copy and sticky bar follow the store's one-free-per-3 rule. Header count = cart.item_count.
   - Displayed-price aware (Elevate A/B price tests): every price here (main price, 1/3 tiles, 3-pack
     builder, picker, rail, ATC, sticky bar) uses the unit price the visitor actually sees. Source order:
     Elevate's window.eab_data + ABTL cookie, else the price shown in [data-yb-price-value] (observed),
     else the Liquid price. With no test running nothing changes. See "displayed unit price" below. */
(() => {
  if (window.__ybInit) return;
  window.__ybInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const readJSON = (el, fb) => { try { return el ? JSON.parse(el.textContent) : fb; } catch (e) { console.warn('[yips-bundle] bad JSON', e); return fb; } };
  const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
  const COLOR_FALLBACK = { white: '#f4f4f0', black: '#111', blue: '#2f5d9e', navy: '#1c2a4a', green: '#2e6b45', red: '#c72222', beige: '#d8c7a6', stone: '#b9b2a2', peach: '#f2b99a', grey: '#8c8c8c', gray: '#8c8c8c', pink: '#f4a6b8', tan: '#c9a982', khaki: '#bfae86', olive: '#6b6b3a', lime: '#c8e05a', yellow: '#e5c94a', orange: '#f07822', brown: '#8b5a35', purple: '#6f4aa8' };

  function init(root) {
    const cfg = readJSON($('[data-yb-config]', root), {});
    const current = readJSON($('[data-yb-current]', root), null);
    if (!current) return;
    const list = readJSON($('[data-yb-products]', root), []);
    const byId = new Map(list.map((p) => [p.id, p]));
    if (!byId.has(current.id)) byId.set(current.id, current);
    const products = [...byId.values()];
    const priceProducts = products.includes(current) ? products : [...products, current]; // current page product can be a separate copy of a list entry
    priceProducts.forEach((p) => p.variants.forEach((v) => { v.basePrice = v.price; v.baseCompare = v.compare; })); // Liquid prices; v.price = displayed price
    const fmt = (cents) => new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    const variantOf = (pid, vid) => byId.get(pid)?.variants.find((v) => v.id === vid);
    const firstAvail = (p) => p.variants.find((v) => v.available) || null;
    const colors = (p) => [...new Set(p.variants.map((v) => v.color).filter(Boolean))];
    const swatchStyle = (p, v) => {
      const sw = p.swatches?.[v.color] || {};
      if (sw.image) return `background-image:url('${sw.image}')`;
      if (sw.color) return `background-color:${sw.color}`;
      const key = Object.keys(COLOR_FALLBACK).find((k) => String(v.color || '').toLowerCase().includes(k));
      if (key) return `background-color:${COLOR_FALLBACK[key]}`;
      return v.image ? `background-image:url('${v.image}')` : '';
    };

    const el = {
      input: $('[data-yb-variant-input]', root), form: $('[data-yb-form]', root), atc: $('[data-yb-atc]', root),
      atcLabel: $('[data-yb-atc-label]', root), stock: $('[data-yb-stock]', root), stockText: $('[data-yb-stock-text]', root),
      price: $('[data-yb-price-value]', root), colorName: $('[data-yb-color-name]', root), error: $('[data-yb-error]', root),
      live: $('[data-yb-live]', root), slots: $('[data-yb-slots]', root), count: $('[data-yb-pack-count]', root),
      progress: $('[data-yb-progress]', root), summary: $('[data-yb-summary]', root), hint: $('[data-yb-hint]', root),
      sheet: $('[data-yb-sheet]', root), grid: $('[data-yb-grid]', root), sheetTitle: $('[data-yb-sheet-title]', root),
      rail: $('[data-yb-rail]', root), sticky: $('[data-yb-sticky]', root), stickyBtn: $('[data-yb-sticky-btn]', root),
      stickySub: $('[data-yb-sticky-sub]', root), track: $('[data-yb-track]', root), counter: $('[data-yb-counter]', root),
    };

    const params = new URLSearchParams(location.search);
    let currentVariant = current.variants.find((v) => String(v.id) === params.get('variant')) || firstAvail(current) || current.variants[0];
    const state = {
      mode: cfg.inBundle ? root.dataset.mode : 'single',
      slots: [null, null, null],
      slot1Follows: true,
      sheetSlot: null, filter: 'all', returnFocus: null, busy: false,
    };
    if (currentVariant.available) state.slots[0] = { pid: current.id, vid: currentVariant.id };


    /* ---------- displayed unit price (Elevate A/B price tests) ----------
       v.basePrice = Liquid price; v.price = the unit price this visitor sees (all math below uses v.price).
       1) Elevate: window.eab_data.allTests[test][variation].prices (v2: { price: { USD: { "35.00": [variantIds] } }, compare: ... })
          for the variation in the visitor's ABTL cookie. Used when the test isLive, or once the page shows that price (Elevate preview).
       2) Otherwise, if something (Elevate's price rewrite) changes the main price text, that shown price is the unit price
          for every variant at the same Liquid price (scoped to the test's products when eab_data lists them).
       3) Otherwise the Liquid price, i.e. exactly the old behaviour. */
    const priceBox = $('[data-yb-price]', root);
    const parseMoney = (txt) => {
      const m = String(txt || '').replace(/\u00a0/g, ' ').match(/(\d{1,3}(?:[,.\s]\d{3})+|\d+)(?:[.,](\d{1,2}))?(?!\d)/);
      if (!m) return null;
      const whole = Number(m[1].replace(/[,.\s]/g, ''));
      return Number.isFinite(whole) ? whole * 100 + (m[2] ? Number(m[2].padEnd(2, '0')) : 0) : null;
    };
    const readCookieJSON = (name) => {
      const c = document.cookie.split('; ').find((x) => x.startsWith(name + '='));
      if (!c) return null;
      let raw = c.slice(name.length + 1);
      for (let k = 0; k < 2; k++) { try { return JSON.parse(raw); } catch (e) { try { raw = decodeURIComponent(raw); } catch (x) { return null; } } }
      return null;
    };
    const toCents = (x) => { const n = Math.round(parseFloat(String(x).replace(/[^0-9.]/g, '')) * 100); return Number.isFinite(n) ? n : null; };
    function readPriceTable(tbl, cur, out) {
      if (!tbl || typeof tbl !== 'object') return;
      const byCur = tbl[cur] || null;
      if (!byCur || typeof byCur !== 'object') return;
      Object.entries(byCur).forEach(([amount, ids]) => {
        const cents = toCents(amount); if (cents == null) return;
        (Array.isArray(ids) ? ids : [ids]).forEach((id) => out.set(Number(id), cents));
      });
    }
    function eabPrices() {
      const d = window.eab_data; const all = d && d.allTests;
      if (!all || typeof all !== 'object') return null;
      const cur = (d.environment && d.environment.activeCurrency) || cfg.currency || 'USD';
      if (cfg.currency && cur !== cfg.currency) return null;
      const abtl = readCookieJSON('ABTL') || {};
      const res = { price: new Map(), compare: new Map(), live: false, productIds: new Set(), testId: null, variationId: null };
      Object.keys(all).forEach((tid) => {
        if (tid === 'settings') return;
        const t = all[tid]; const data = t && t.data;
        if (!data || data.type !== 'PRICE_PLUS') return;
        if (Array.isArray(data.currencies) && data.currencies.length && !data.currencies.includes(cur)) return;
        (data.productIds || []).forEach((id) => res.productIds.add(Number(id)));
        const vid = abtl[tid]; const variation = vid != null ? t[vid] : null;
        if (!variation || variation.isControl || variation.isDone || !variation.prices) return;
        const pr = variation.prices;
        readPriceTable(pr.price, cur, res.price); readPriceTable(pr.compare, cur, res.compare);
        if (data.isLive) res.live = true;
        res.testId = tid; res.variationId = String(vid);
      });
      return res;
    }
    function displayedCents() {
      if (!priceBox) return null;
      const valEl = $('[data-yb-price-value]', priceBox);
      if (valEl) return parseMoney(valEl.textContent);
      const c = priceBox.cloneNode(true); $$('s, del, .yb__compare', c).forEach((n) => n.remove()); // Elevate replaced the inner markup
      return parseMoney(c.textContent);
    }
    let domOverride = null; // { base, cents, compare }
    let eabConfirmed = false;
    let priceSource = 'liquid';
    let eabInfo = null;
    function computePrices() {
      const e = eabInfo = eabPrices();
      if (e && !e.live && !eabConfirmed && e.price.has(currentVariant.id) && displayedCents() === e.price.get(currentVariant.id)) eabConfirmed = true;
      const useEab = !!(e && e.price.size && (e.live || eabConfirmed));
      priceSource = 'liquid';
      priceProducts.forEach((p) => p.variants.forEach((v) => {
        let price = v.basePrice, compare = v.baseCompare, src = 'liquid';
        if (useEab && e.price.has(v.id)) {
          price = e.price.get(v.id); if (e.compare.has(v.id)) compare = e.compare.get(v.id); src = 'elevate';
        } else if (domOverride && v.basePrice === domOverride.base && (p.id === current.id || !e || !e.productIds.size || e.productIds.has(p.id))) {
          price = domOverride.cents; if (domOverride.compare != null) compare = domOverride.compare; src = 'display';
        }
        v.price = price; v.compare = compare;
        if (v === currentVariant) priceSource = src;
      }));
    }
    const priceSig = () => priceProducts.map((p) => p.variants.map((v) => `${v.price}/${v.compare}`).join(',')).join(';');
    let lastPriceSig = priceSig();
    function writeMainPrice() {
      const v = currentVariant;
      if (el.price && displayedCents() !== v.price) el.price.textContent = fmt(v.price);
      if (!priceBox) return;
      let cmp = $('.yb__compare', priceBox);
      const showCmp = v.compare > v.price;
      if (!cmp && showCmp && el.price) { cmp = document.createElement('s'); cmp.className = 'yb__compare'; cmp.setAttribute('data-yips-price-role', 'unit-compare'); el.price.parentNode.insertBefore(cmp, el.price); }
      if (cmp) {
        if (showCmp && parseMoney(cmp.textContent) !== v.compare) cmp.textContent = fmt(v.compare);
        if (cmp.hidden === showCmp) cmp.hidden = !showCmp;
      }
      writeOffPill();
    }
    /* BF: "% OFF" pill next to the main price, from the displayed price vs compare-at (outside [data-yb-price], so it never trips the price observer) */
    const pctOff = (price, compare) => (compare > 0 && compare > price ? Math.round((1 - price / compare) * 100) : 0);
    function writeOffPill() {
      const pill = $('[data-yb-off-pill]', root); if (!pill) return;
      const pct = pctOff(currentVariant.price, currentVariant.compare), txt = `${pct}% OFF`;
      if (pct > 0 && pill.textContent !== txt) pill.textContent = txt;
      if (pill.hidden === pct > 0) pill.hidden = !(pct > 0);
    }
    function stampPrices() {
      const p = currentVariant.price;
      root.setAttribute('data-yips-unit-price', p);
      root.setAttribute('data-yips-base-price', currentVariant.basePrice);
      root.setAttribute('data-yips-price-source', priceSource);
      $$('[data-yips-price-role]', root).forEach((n) => n.setAttribute('data-yips-unit-price', p));
    }
    function refreshPrices({ fromDom = false } = {}) {
      try {
        computePrices();
        if (!fromDom) writeMainPrice(); // never fight a DOM rewrite (no write loops)
        const sig = priceSig();
        if (sig !== lastPriceSig) {
          lastPriceSig = sig;
          renderRail();
          if (el.sheet && !el.sheet.hidden) renderGrid();
          render();
        } else stampPrices();
      } catch (err) { console.warn('[yips-bundle] price sync', err); }
    }
    function onDisplayedPrice() {
      const shown = displayedCents();
      if (shown == null || shown <= 0 || shown === currentVariant.price) { refreshPrices({ fromDom: true }); return; }
      if (shown === currentVariant.basePrice) domOverride = null; // back to the normal price
      else {
        const cmpEl = priceBox && $('s, del, .yb__compare', priceBox);
        const cc = cmpEl && !cmpEl.hidden ? parseMoney(cmpEl.textContent) : null;
        domOverride = { base: currentVariant.basePrice, cents: shown, compare: cc && cc > shown ? cc : null };
      }
      refreshPrices({ fromDom: true });
    }

    const announce = (msg) => { if (!el.live) return; el.live.textContent = ''; setTimeout(() => { el.live.textContent = msg; }, 30); };
    const showError = (msg) => { if (!el.error) return; el.error.textContent = msg || ''; el.error.hidden = !msg; };

    /* ---------- cart awareness (hats already in the cart) ---------- */
    const eligible = new Set((Array.isArray(cfg.eligibleProductIds) ? cfg.eligibleProductIds : []).map(Number));
    products.forEach((p) => eligible.add(p.id));
    const isHatLine = (l) => eligible.has(Number(l.product_id)) && Number(l.original_price ?? l.price) > 0;
    const cs = { known: false, sig: '', hats: 0, rem: 0, free: 0, locked: [] }; // locked = in-cart hats counting toward the open 3-pack
    const setHeaderCount = (count) => {
      if (typeof count !== 'number') return;
      $$('[data-yips-cart-count]').forEach((n) => {
        if (n.textContent !== String(count)) n.textContent = count;
        const a = n.closest('a'); if (a && a.hasAttribute('aria-label')) a.setAttribute('aria-label', `Cart with ${count} items`);
      });
    };
    function resetPack() {
      const need = 3 - cs.locked.length;
      state.slots = Array(need).fill(null);
      state.slot1Follows = true;
      if (currentVariant.available) state.slots[0] = { pid: current.id, vid: currentVariant.id };
      if (state.sheetSlot != null && state.sheetSlot >= need) closeSheet();
    }
    function applyCart(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      setHeaderCount(cart.item_count);
      if (!cfg.inBundle) return;
      const units = [];
      cart.items.forEach((l) => { if (isHatLine(l)) for (let k = 0; k < l.quantity; k++) units.push(l); });
      const sig = units.map((l) => l.key).join('|');
      const changed = !cs.known || sig !== cs.sig;
      const rem = units.length % 3;
      Object.assign(cs, {
        known: true, sig, hats: units.length, rem, free: Math.floor(units.length / 3),
        // cart.js lists newest lines first: the newest "rem" hats are the ones in the open 3-pack
        locked: units.slice(0, rem).map((l) => ({ pid: Number(l.product_id), vid: Number(l.variant_id), title: l.product_title, variant: l.variant_title, image: l.image, price: Number(l.original_price ?? l.price) })),
      });
      if (changed) resetPack(); // any cart change (add, drawer removal) rebuilds the pack, so nothing stale or duplicate can be re-added
      render();
    }
    async function syncCart() {
      const cart = await fetch(cfg.cartJsUrl || '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
      applyCart(cart);
      return cart;
    }
    let syncTimer;
    const scheduleSync = (ms = 350) => { clearTimeout(syncTimer); syncTimer = setTimeout(syncCart, ms); };

    /* ---------- bundle math (preview only, discount itself is the store's) ---------- */
    const filled = () => state.slots.map((s, i) => (s ? { ...s, i, p: byId.get(s.pid), v: variantOf(s.pid, s.vid) } : null)).filter(Boolean);
    const qtyInPack = (vid, exceptIndex = -1) => state.slots.reduce((n, s, i) => n + (s && s.vid === vid && i !== exceptIndex ? 1 : 0), 0);
    const canAdd = (v, slotIndex) => v.available && (v.max == null || qtyInPack(v.id, slotIndex) + 1 <= v.max);
    function totals() {
      const items = filled();
      const L = cs.locked.length, need = state.slots.length;
      const subtotal = items.reduce((t, x) => t + x.v.price, 0);
      let freeIdx = -1, free = 0, freeInCart = false;
      if (items.length === need) {
        let min = Infinity;
        items.forEach((x) => { if (x.v.price <= min) { min = x.v.price; freeIdx = x.i; } });
        cs.locked.forEach((h) => { if (h.price < min) { min = h.price; freeIdx = -1; freeInCart = true; } });
        free = Number.isFinite(min) ? min : 0;
      }
      // total = what this add changes the cart total by (preview; the store applies the discount)
      return { items, subtotal, free, total: subtotal - free, freeIdx, freeInCart, need, L, k: L + items.length };
    }
    const money0 = (c) => (c > 0 ? fmt(c) : 'FREE');
    /* regular (compare-at) total of the picked hats; 0 unless at least one has a compare-at above its price */
    const regularTotal = (t) => { let any = false; const r = t.items.reduce((s, x) => { const c = x.v.compare > x.v.price ? x.v.compare : 0; if (c) any = true; return s + (c || x.v.price); }, 0); return any ? r : 0; };
    // single hat added on top of the cart: free when it completes a 3-pack and is the cheapest
    const singleDelta = () => (cs.rem === 2 ? currentVariant.price - Math.min(currentVariant.price, ...cs.locked.map((h) => h.price)) : currentVariant.price);

    /* ---------- color-filtered photos: an image whose alt names a color shows only for that color ---------- */
    function ybFilterMedia(v) {
      const gal = $('[data-yb-gallery]', root);
      if (!gal || !el.track || !v) return;
      const h = (x) => String(x || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const color = h(v.color);
      const slides = $$('[data-yb-slide]', el.track);
      const dots = $$('[data-yb-dot]', root);
      const tagged = slides.filter((s) => s.dataset.ybMcolor);
      const useFilter = !!color && tagged.some((s) => s.dataset.ybMcolor.includes(color));
      let n = 0;
      slides.forEach((s, i) => {
        const show = !useFilter || !s.dataset.ybMcolor || s.dataset.ybMcolor.includes(color);
        s.hidden = !show;
        if (dots[i]) dots[i].hidden = !show;
        if (show) n += 1;
      });
      dots.forEach((d) => d.removeAttribute('aria-current'));
      const firstDot = dots.find((d) => !d.hidden); if (firstDot) firstDot.setAttribute('aria-current', 'true');
      const dotsWrap = $('[data-yb-dots]', root); if (dotsWrap) dotsWrap.hidden = n < 2;
      const cnt = $('.yb__counter', root); if (cnt) cnt.hidden = n < 2;
      const tot = $('[data-yb-total]', root); if (tot) tot.textContent = n;
      if (el.counter) el.counter.textContent = 1;
      el.track.scrollTo({ left: 0, behavior: 'auto' });
    }
    /* ---------- current product variant (in-place, no reload) ---------- */
    function setVariant(vid, { fromUser = false } = {}) {
      const v = current.variants.find((x) => x.id === Number(vid));
      if (!v) return;
      currentVariant = v;
      if (el.input) el.input.value = v.id;
      writeMainPrice(); // v.price = displayed unit price (Elevate test price when active)
      if (el.colorName && v.color) el.colorName.textContent = v.color;
      $$('[data-yb-swatch]', root).forEach((a) => a.setAttribute('aria-checked', String(Number(a.dataset.ybSwatch) === v.id)));
      syncOptions(v);
      const single = $('[data-yb-tile-single]', root); if (single) single.textContent = fmt(v.price);
      if (state.slot1Follows && cfg.inBundle) state.slots[0] = v.available ? { pid: current.id, vid: v.id } : null;
      ybFilterMedia(v);
      if (v.mediaId && el.track) {
        const slide = $(`[data-yb-slide][data-media-id="${v.mediaId}"]`, el.track);
        if (slide) el.track.scrollTo({ left: slide.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      if (fromUser) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
        announce(`${v.color || v.title} selected${v.available ? '' : ', sold out'}`);
      }
      render();
    }
    /* ---------- non-color options (size etc.) ---------- */
    const optSets = $$('[data-yb-option]', root);
    const sameExcept = (x, opts, oi) => (x.options || []).every((o, k) => k === oi || o === opts[k]);
    function syncOptions(v) {
      if (!v.options) return;
      optSets.forEach((fs) => {
        const oi = Number(fs.dataset.ybOption);
        const nm = $('[data-yb-opt-name]', fs); if (nm) nm.textContent = v.options[oi];
        $$('[data-yb-opt-value]', fs).forEach((b) => {
          const val = b.dataset.ybOptValue;
          b.setAttribute('aria-checked', String(val === v.options[oi]));
          b.tabIndex = val === v.options[oi] ? 0 : -1;
          const m = current.variants.find((x) => x.options && x.options[oi] === val && sameExcept(x, v.options, oi));
          b.classList.toggle('is-soldout', !(m && m.available));
        });
      });
    }
    function pickOption(oi, val) {
      const want = (currentVariant.options || []).slice(); want[oi] = val;
      const withVal = current.variants.filter((x) => x.options && x.options[oi] === val);
      const v = withVal.find((x) => sameExcept(x, want, oi)) || withVal.find((x) => x.available) || withVal[0];
      if (v) setVariant(v.id, { fromUser: true });
    }
    optSets.forEach((fs) => {
      const oi = Number(fs.dataset.ybOption);
      fs.addEventListener('click', (e) => { const b = e.target.closest('[data-yb-opt-value]'); if (b) { e.preventDefault(); pickOption(oi, b.dataset.ybOptValue); } });
      fs.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        const items = $$('[data-yb-opt-value]', fs); const i = items.indexOf(document.activeElement);
        if (i < 0) return; e.preventDefault();
        const nx = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        nx.focus(); pickOption(oi, nx.dataset.ybOptValue);
      });
    });

    $$('[data-yb-swatch]', root).forEach((a) => a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" work
      e.preventDefault();
      setVariant(a.dataset.ybSwatch, { fromUser: true });
    }));
    const swList = $('.yb__swatch-list', root);
    if (swList) {
      swList.setAttribute('role', 'radiogroup');
      swList.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        const items = $$('[data-yb-swatch]', swList); const i = items.indexOf(document.activeElement);
        if (i < 0) return; e.preventDefault();
        const n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        n.focus(); setVariant(n.dataset.ybSwatch, { fromUser: true });
      });
    }

    /* ---------- mode tiles (radiogroup) ---------- */
    const tiles = $$('[data-yb-mode]', root);
    function setMode(mode, focus) {
      state.mode = mode; root.dataset.mode = mode; showError('');
      tiles.forEach((t) => { const on = t.dataset.ybMode === mode; t.setAttribute('aria-checked', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      render();
    }
    tiles.forEach((t) => {
      t.addEventListener('click', () => setMode(t.dataset.ybMode));
      t.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault(); if (tileBundle && tileBundle.hidden) return; setMode(state.mode === 'single' ? 'bundle' : 'single', true);
      });
    });

    /* ---------- render ---------- */
    function render() {
      const single = state.mode === 'single';
      const t = totals();
      const n = t.items.length, need = t.need, L = t.L;
      if (cfg.inBundle && el.slots) renderSlots(t);
      if (cfg.inBundle) { renderTiles(); renderCartNote(); }
      const sDelta = cfg.inBundle ? singleDelta() : currentVariant.price;
      // stock + ATC
      let label, labelHtml = '', disabled = false, stockTxt, out = false;
      /* new 3-pack: regular total from compare-at (3 x $44 = $132); 0 when no hat in it has a compare-at */
      const reg = !single && L === 0 && n === need ? regularTotal(t) : 0;
      if (single) {
        disabled = !currentVariant.available;
        label = disabled ? cfg.soldOutLabel : `Add to cart\u00a0⋅\u00a0${money0(sDelta)}`;
        out = disabled;
        stockTxt = disabled ? cfg.stockOut : cfg.stockReady;
      } else {
        if (n < need) { disabled = true; label = `Pick ${plural(need - n, 'more hat')}`; stockTxt = cfg.stockReady; }
        else {
          label = L > 0 ? `Complete 3-pack\u00a0⋅\u00a0${money0(t.total)}` : `${cs.hats >= 3 ? 'Add another 3-pack' : 'Add bundle to cart'}\u00a0⋅\u00a0${fmt(t.total)}`;
          if (reg > t.total) labelHtml = `${cs.hats >= 3 ? 'Add another 3-pack' : 'Add bundle to cart'}\u00a0⋅\u00a0<s class="yb__compare">${esc(fmt(reg))}</s>${esc(fmt(t.total))}`;
          stockTxt = need === 3 ? 'All 3 in stock, ready to ship' : need === 2 ? 'Both in stock, ready to ship' : cfg.stockReady;
        }
      }
      if (el.atc) { el.atc.disabled = disabled || state.busy; el.atc.setAttribute('aria-disabled', String(disabled)); }
      if (el.atcLabel) { if (labelHtml) el.atcLabel.innerHTML = labelHtml; else el.atcLabel.textContent = label; }
      if (el.stockText) el.stockText.textContent = stockTxt;
      if (el.stock) el.stock.classList.toggle('is-out', out);
      if (el.stickyBtn) {
        const sTxt = single
          ? (disabled ? cfg.soldOutLabel : (sDelta === 0 ? 'Add\u00a0⋅\u00a0FREE' : (cfg.inBundle ? 'Add to cart' : `Add\u00a0⋅\u00a0${money0(sDelta)}`)))
          : (n < need ? (L > 0 ? 'Finish 3-pack' : cs.hats >= 3 ? 'Build another' : 'Build 3-pack') : `Add ${n}\u00a0⋅\u00a0${money0(t.total)}`);
        if (!single && n >= need && reg > t.total) el.stickyBtn.innerHTML = `<span>Add ${n}\u00a0⋅\u00a0<s class="yb__compare">${esc(fmt(reg))}</s>${esc(fmt(t.total))}</span>`;
        else el.stickyBtn.textContent = sTxt;
      }
      if (el.stickyBtn) el.stickyBtn.disabled = single && disabled;
      if (el.stickySub) {
        const cv = currentVariant, sCmp = cv.compare > cv.price ? `<s class="yb__compare">${esc(fmt(cv.compare))}</s> ` : '';
        const mp = nonHat ? mixPack(3) : null;
        let sub = cfg.inBundle ? (mp ? `${sCmp}${esc(fmt(cv.price))} ⋅ ${mp.from ? '3-pack from' : '3 for'} ${esc(fmt(mp.total))}` : `${sCmp}${esc(fmt(cv.price))} ⋅ 3 for ${esc(fmt(cv.price * 2))}`) : `${sCmp}${esc(fmt(cv.price))}`;
        if (cfg.inBundle && cs.hats > 0) {
          sub = esc(cs.rem === 0 ? `✓ 3-pack in cart ⋅ ${fmt(cv.price)}`
            : cs.rem === 1 ? `${cs.hats} in cart ⋅ 2 more, 1 FREE`
            : `${cs.hats} in cart ⋅ next hat FREE`);
        }
        if (el.stickySub.innerHTML !== sub) el.stickySub.innerHTML = sub;
      }
      stampPrices();
    }

    /* tiles + "in your cart" note follow the cart */
    const tileSingle = $('[data-yb-mode="single"]', root), tileBundle = $('[data-yb-mode="bundle"]', root);
    const tileSingleSub = tileSingle && $('.yb__tile-sub', tileSingle);
    const tileBundleName = tileBundle && $('.yb__tile-name', tileBundle);
    const tileBundleSub = tileBundle && $('.yb__tile-sub--save', tileBundle);
    /* non-hat pages (e.g. visor): the 3-pack is mix & match, so tiles price this item + the cheapest other eligible hats, cheapest item free (same rule as the store's discount) */
    const nonHat = !!current.noun && current.noun !== 'hat';
    const cheapestOther = () => {
      let best = null;
      products.forEach((p) => { if (p.id === current.id) return; p.variants.forEach((v) => { if (v.available && v.price > 0 && (!best || v.price < best.price)) best = v; }); });
      return best;
    };
    /* what a mix & match pack adds to the cart: this item + (need - 1) cheapest others, cheapest of pack + in-cart units free */
    const mixPack = (need) => {
      const p = currentVariant.price, ch = cheapestOther();
      if (!ch) return null;
      const units = [p, ...Array(Math.max(need - 1, 0)).fill(ch.price)];
      const sub = units.reduce((a, b) => a + b, 0);
      const free = Math.min(...units, ...cs.locked.map((h) => h.price));
      const reg = (currentVariant.compare > p ? currentVariant.compare : p) + (need - 1) * (ch.compare > ch.price ? ch.compare : ch.price);
      return { sub, free, total: sub - free, reg, from: ch.price < p }; /* 'from' only when a cheaper item sets the pack price */
    };
    function renderMixTile(L, need) {
      const m = mixPack(need);
      if (!m) return false;
      if (tileBundleName) tileBundleName.textContent = L === 0 ? '3-Pack (mix & match)' : L === 1 ? '+2 more' : '+1 more';
      const three = $('[data-yb-tile-three]', root), cmp = $('[data-yb-tile-three-compare]', root);
      if (three) three.innerHTML = m.from ? `<span class="yb__tile-from">from</span> ${esc(money0(m.total))}` : esc(money0(m.total));
      const strike = L === 0 ? m.reg : m.sub; // new pack: regular (compare-at) prices; in-cart pack: undiscounted price, like hat pages
      if (cmp) { cmp.textContent = fmt(strike); cmp.hidden = !(strike > m.total); }
      if (tileBundleSub) tileBundleSub.innerHTML = L === 0
        ? (m.reg > m.total ? `Save <span data-yb-tile-save-amt>${esc(fmt(m.reg - m.total))}</span>` : `Save ${esc(fmt(m.free))} ⋅ 1 free`)
        : `Completes 3-pack ⋅ ${esc(fmt(m.free))} off`;
      return true;
    }
    function renderTiles() {
      const p = currentVariant.price, L = cs.locked.length, need = 3 - L;
      const sub = p * need;
      const save = Math.min(p, ...cs.locked.map((h) => h.price));
      const sD = singleDelta();
      const single = $('[data-yb-tile-single]', root);
      if (single) single.innerHTML = sD < p ? `${sD > 0 ? fmt(sD) : 'FREE'} <s class="yb__compare">${fmt(p)}</s>` : esc(fmt(p));
      /* 1-hat compare-at strike (variant / test compare); hidden when the cart-delta strike shows */
      const singleCmp = $('[data-yb-tile-single-compare]', root);
      if (singleCmp) {
        const c = currentVariant.compare, showC = !(sD < p) && c > p;
        if (showC) singleCmp.textContent = fmt(c);
        if (singleCmp.hidden === showC) singleCmp.hidden = !showC;
      }
      const offPct = pctOff(p, currentVariant.compare);
      if (tileSingleSub) {
        if (cs.rem === 2) tileSingleSub.textContent = 'Completes your 3-pack';
        else if (cs.rem === 1) tileSingleSub.textContent = '1 more after this is FREE';
        else tileSingleSub.innerHTML = offPct > 0 && !(sD < p) ? `<span class="yb__tile-just">Just this one ⋅ </span><b class="yb__tile-off">${offPct}% off</b>` : 'Just this one';
      }
      writeOffPill();
      const mixed = nonHat && renderMixTile(L, need);
      let packSave = 0;
      if (!mixed) {
      if (tileBundleName) tileBundleName.textContent = L === 0 ? '3 Hats' : L === 1 ? '+2 Hats' : '+1 Hat';
      const three = $('[data-yb-tile-three]', root), cmp = $('[data-yb-tile-three-compare]', root);
      if (three) three.textContent = money0(sub - save);
      /* 3-pack strike = 3 x compare-at ($132) when on sale; otherwise 3 x price as before */
      const cAt = currentVariant.compare, onSale = L === 0 && cAt > p;
      if (cmp) cmp.textContent = fmt(onSale ? cAt * 3 : sub);
      packSave = onSale ? cAt * 3 - (sub - save) : 0;
      }
      /* next hat is free (2 extra hats in cart): one clear option, the single hat */
      const solo = cs.known && cs.rem === 2;
      if (tileBundle) tileBundle.hidden = solo;
      const tilesWrap = tileBundle && tileBundle.parentNode; if (tilesWrap) tilesWrap.classList.toggle('is-solo', solo);
      if (solo && state.mode === 'bundle') queueMicrotask(() => { if (state.mode === 'bundle' && tileBundle.hidden) setMode('single'); });
      /* 3-pack saving in dollars vs 3 x compare-at: $132 - $70 = Save $62 */
      if (tileBundleSub && !mixed) tileBundleSub.innerHTML = packSave > 0 ? `Save <span data-yb-tile-save-amt>${esc(fmt(packSave))}</span>` : L === 0 ? `Save <span data-yb-tile-save data-yips-price-role="tile-3-save" data-yips-multiplier="1">${esc(fmt(save))}</span> ⋅ 1 free` : `Completes 3-pack ⋅ <span data-yb-tile-save data-yips-price-role="tile-3-save" data-yips-multiplier="1">${esc(fmt(save))}</span> off`;
    }
    let noteEl = null;
    function renderCartNote() {
      if (!noteEl) {
        const anchor = $('.yb__bundle-head', root); if (!anchor) return;
        noteEl = document.createElement('div');
        noteEl.className = 'yb__cartnote'; noteEl.setAttribute('data-yb-cartnote', ''); noteEl.setAttribute('role', 'status'); noteEl.hidden = true;
        anchor.parentNode.insertBefore(noteEl, anchor);
        noteEl.addEventListener('click', (e) => {
          const b = e.target.closest('[data-yb-viewcart]'); if (!b) return;
          if (typeof window.upcartOpenCart === 'function') { e.preventDefault(); window.upcartOpenCart(); }
        });
      }
      if (!cs.known || cs.hats === 0) { noteEl.hidden = true; return; }
      const freeTxt = cs.free > 0 ? ` ⋅ ${plural(cs.free, 'free hat')} unlocked` : '';
      let title, sub;
      if (cs.rem === 0) { title = cs.hats === 3 ? 'Your 3-pack is in your cart' : `${cs.hats} hats in your cart`; sub = `${plural(cs.free, 'free hat')} unlocked. Want more? Build another 3-pack or add a single hat.`; }
      else if (cs.rem === 1) { title = `${plural(cs.hats, 'hat')} in your cart`; sub = `Add 2 more and 1 is FREE${freeTxt}.`; }
      else { title = `${plural(cs.hats, 'hat')} in your cart`; sub = `Your next hat is FREE${freeTxt}.`; }
      noteEl.innerHTML = `<span class="yb__cartnote-icon" aria-hidden="true">${cs.rem === 0 ? '✓' : cs.hats}</span>
        <span class="yb__cartnote-text"><strong>${esc(title)}</strong><span>${esc(sub)}</span></span>
        <a class="yb__cartnote-btn" href="${esc(cfg.cartUrl || '/cart')}" data-yb-viewcart>View cart</a>`;
      noteEl.dataset.rem = cs.rem;
      noteEl.hidden = false;
    }

    function renderSlots(t) {
      const n = t.items.length, need = t.need, L = t.L, k = t.k;
      const active = state.slots.findIndex((s) => !s);
      const minSelected = Math.min(...t.items.map((x) => x.v.price), ...cs.locked.map((h) => h.price));
      const freeNoun = t.freeIdx >= 0 ? byId.get(state.slots[t.freeIdx].pid).noun : 'hat';
      const lockedHtml = cs.locked.map((h, j) => `<li class="yb__slot is-filled is-incart">
          <div class="yb__slot-btn" role="img" aria-label="Hat ${j + 1}: ${esc(h.title)}, already in your cart">
            <img class="yb__slot-img" src="${esc(h.image)}" alt="" loading="lazy" width="80" height="80">
            <span class="yb__slot-name">${esc(h.title)}</span>
          </div>
          <span class="yb__pill yb__pill--muted yb__slot-tag" aria-hidden="true">In cart</span>
        </li>`).join('');
      el.slots.innerHTML = lockedHtml + state.slots.map((s, i) => {
        const lastEmpty = state.slots.map((x, j) => (x ? -1 : j)).filter((j) => j >= 0).pop();
        const visorPicked = minSelected < currentVariant.price;
        const isFree = n === need ? i === t.freeIdx : (!s && i === lastEmpty && !visorPicked);
        if (!s) {
          const txt = isFree ? 'FREE hat' : i === active ? 'Choose' : 'Add a hat';
          return `<li class="yb__slot${i === active ? ' is-active' : ''}${isFree ? ' is-free' : ''}"><button type="button" class="yb__slot-btn" data-yb-slot="${i}" aria-label="Hat ${i + 1 + L}: empty. Choose a hat"><span class="yb__slot-plus" aria-hidden="true">+</span><span>${txt}</span></button></li>`;
        }
        const p = byId.get(s.pid), v = variantOf(s.pid, s.vid);
        const vName = v.color || (p.variants.length > 1 ? v.title : '');
        return `<li class="yb__slot is-filled${isFree ? ' is-free' : ''}">
          <button type="button" class="yb__slot-btn" data-yb-slot="${i}" aria-label="Hat ${i + 1 + L}: ${esc(p.title)}${vName ? ', ' + esc(vName) : ''}${isFree ? ', free item' : ''}. Change">
            <img class="yb__slot-img" src="${esc(v.image || p.image)}" alt="" loading="lazy" width="80" height="80">
            <span class="yb__slot-name">${esc(p.title)}</span>${vName ? `<span class="yb__slot-var">${esc(vName)}</span>` : ''}
          </button>
          ${isFree ? `<span class="yb__pill yb__slot-tag" aria-hidden="true">Free</span>` : ''}
          <button type="button" class="yb__slot-remove" data-yb-remove="${i}" aria-label="Remove ${esc(p.title)} from hat ${i + 1 + L}">×</button>
        </li>`;
      }).join('');
      if (el.count) { el.count.textContent = k === 3 ? (L ? '✓ 3 of 3 with your cart' : '✓ 3 of 3 picked') : k === 2 ? (L ? `2 of 3 ⋅ ${L} in cart ⋅ 1 more FREE` : '2 of 3 ⋅ 1 more, it\'s FREE') : (L ? `${k} of 3 ⋅ ${L} in cart` : `${k} of 3 picked`); el.count.classList.toggle('is-done', k === 3); }
      if (el.progress) { el.progress.setAttribute('aria-valuenow', k); el.progress.firstElementChild.style.width = `${(k / 3) * 100}%`; }
      const title = $('.yb__pack-title', root);
      if (title) title.textContent = L > 0 ? 'Complete your 3-pack' : cs.hats >= 3 ? 'Build another 3-pack' : 'Build your 3-pack';
      if (el.summary) {
        el.summary.hidden = k < 2;
        const what = L ? `${plural(n, 'hat')} + ${L} in cart` : `${n} items`;
        const reg = L === 0 && n === need ? regularTotal(t) : 0;
        if (n === need && reg > t.total) el.summary.innerHTML = `<span>${what}</span><span><s class="yb__compare">${fmt(reg)}</s> <strong>${money0(t.total)}</strong> <span class="yb__pill">Save ${fmt(reg - t.total)}</span></span>`;
        else if (n === need) el.summary.innerHTML = `<span>${what}</span><span><s class="yb__compare">${fmt(t.subtotal)}</s> <strong>${money0(t.total)}</strong> <span class="yb__pill">Save ${fmt(t.free)}</span></span>`;
        else if (k === 2) el.summary.innerHTML = `<span>${nonHat ? 'Add 1 more, it\'s FREE' : 'Add 1 more hat, it\'s FREE'}</span><strong>${fmt(t.subtotal)}</strong>`;
      }
      if (el.hint) {
        /* owner: no 'cheapest item is free' note once the pack is complete; hide the element so there's no gap */
        el.hint.hidden = n === need; el.hint.style.display = n === need ? 'none' : '';
        if (n === need) el.hint.textContent = '';
        else if (k === 2) {
          const cheap = t.items.find((x) => x.v.price === minSelected);
          el.hint.textContent = minSelected < currentVariant.price && cheap
            ? `1 more and the cheapest item is free (that's your ${cheap.p.noun}).`
            : '1 more and it\'s free.';
        }
        else el.hint.textContent = cfg.dealLine || 'Buy 2 hats, get 1 free. No code needed.';
      }
    }

    el.slots?.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-yb-remove]');
      if (rm) {
        const i = Number(rm.dataset.ybRemove); const p = byId.get(state.slots[i].pid);
        state.slots[i] = null; if (i === 0) state.slot1Follows = false;
        render(); announce(`${p.title} removed. ${filled().length + cs.locked.length} of 3 picked${filled().length === state.slots.length - 1 ? ', discount removed' : ''}.`);
        $(`[data-yb-slot="${i}"]`, root)?.focus();
        return;
      }
      const b = e.target.closest('[data-yb-slot]');
      if (b) openSheet(Number(b.dataset.ybSlot), b);
    });

    /* ---------- picker sheet ---------- */
    const cardVariant = new Map(); // pid -> vid chosen in the sheet
    function openSheet(slot, opener) {
      if (!el.sheet) return;
      state.sheetSlot = slot; state.returnFocus = opener || document.activeElement;
      const s = state.slots[slot];
      cardVariant.clear();
      if (s) cardVariant.set(s.pid, s.vid);
      el.sheetTitle.textContent = `Choose hat ${slot + 1 + cs.locked.length}`;
      renderGrid();
      el.sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      $('.yb__sheet-panel', el.sheet).focus();
    }
    function closeSheet() {
      if (!el.sheet || el.sheet.hidden) return;
      el.sheet.hidden = true; document.documentElement.style.overflow = '';
      const f = state.returnFocus; state.returnFocus = null;
      if (f && document.contains(f)) f.focus();
    }
    function renderGrid() {
      const slot = state.sheetSlot; const s = state.slots[slot];
      const show = products.filter((p) => state.filter === 'all' || colors(p).length > 1);
      el.grid.innerHTML = show.map((p) => {
        const vid = cardVariant.get(p.id) ?? (firstAvail(p) || p.variants[0]).id;
        const v = p.variants.find((x) => x.id === vid);
        const selected = s && s.pid === p.id && s.vid === v.id;
        const ok = canAdd(v, slot);
        const soldOut = !p.available;
        const capped = v.available && !ok;
        const cs = colors(p);
        const sw = cs.length > 1 ? `<div class="yb__mini-swatches" role="radiogroup" aria-label="${esc(p.title)} color">${p.variants.filter((x) => x.color).map((x) => `<button type="button" class="yb__mini-swatch${x.available ? '' : ' is-soldout'}" role="radio" aria-checked="${x.id === v.id}" data-yb-card-variant="${p.id}:${x.id}" aria-label="${esc(x.color)}${x.available ? '' : ' (sold out)'}" ${x.available ? '' : 'disabled'}><span style="${swatchStyle(p, x)}"></span></button>`).join('')}</div>` : '';
        const btnText = soldOut || !v.available ? 'Sold out' : selected ? '✓ Selected' : capped ? `Only ${v.max} in stock` : 'Select';
        const btnCls = selected ? 'button' : 'button-secondary';
        return `<li class="yb__card${selected ? ' is-selected' : ''}${soldOut ? ' is-soldout' : ''}">
          ${soldOut ? '<span class="yb__pill yb__pill--muted yb__card-tag">Sold out</span>' : (p.noun === 'visor' ? '<span class="yb__pill yb__card-tag">Visor</span>' : '')}
          <div class="yb__card-img"><img src="${esc(v.image || p.image)}" alt="" loading="lazy" width="200" height="200"></div>
          <span class="yb__card-title">${esc(p.title)}</span>
          <span class="yb__card-price">${fmt(v.price)}${v.color && cs.length > 1 ? ' ⋅ ' + esc(v.color) : ''}</span>
          ${sw}
          <button type="button" class="${btnCls} yb__card-btn" data-yb-pick="${p.id}:${v.id}" ${(!v.available || capped) ? 'disabled aria-disabled="true"' : ''} aria-label="${esc(btnText)}: ${esc(p.title)}${v.color ? ', ' + esc(v.color) : ''}, ${fmt(v.price)}">${btnText}</button>
        </li>`;
      }).join('') || '<li class="yb__card-note">No hats match this filter.</li>';
    }
    el.sheet?.addEventListener('click', (e) => {
      if (e.target.closest('[data-yb-sheet-close]')) return closeSheet();
      const f = e.target.closest('[data-yb-filter]');
      if (f) { state.filter = f.dataset.ybFilter; $$('[data-yb-filter]', el.sheet).forEach((c) => c.setAttribute('aria-pressed', String(c === f))); renderGrid(); return; }
      const cv = e.target.closest('[data-yb-card-variant]');
      if (cv) { const [pid, vid] = cv.dataset.ybCardVariant.split(':').map(Number); cardVariant.set(pid, vid); renderGrid(); $(`[data-yb-card-variant="${pid}:${vid}"]`, el.grid)?.focus(); return; }
      const pick = e.target.closest('[data-yb-pick]');
      if (pick && !pick.disabled) {
        const [pid, vid] = pick.dataset.ybPick.split(':').map(Number);
        const slot = state.sheetSlot;
        state.slots[slot] = { pid, vid }; if (slot === 0) state.slot1Follows = false;
        const p = byId.get(pid); const v = variantOf(pid, vid);
        render();
        const n = filled().length;
        state.returnFocus = $(`[data-yb-slot="${state.slots.findIndex((x) => !x)}"]`, root) || el.atc;
        closeSheet();
        announce(`${p.title}${v.color ? ' in ' + v.color : ''} added as hat ${slot + 1 + cs.locked.length}. ${n + cs.locked.length} of 3 picked.${n === state.slots.length ? ' Bundle ready.' : ''}`);
      }
    });
    el.sheet?.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])', $('.yb__sheet-panel', el.sheet)).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.yb__sheet-panel', el.sheet))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------- "Make it three" rail ---------- */
    function renderRail() {
      if (!el.rail) return;
      el.rail.innerHTML = products.filter((p) => p.id !== current.id).map((p) => {
        const v = firstAvail(p) || p.variants[0];
        return `<li><div class="yb__rail-card">
          <div class="yb__rail-img"><a href="${esc(p.url)}" tabindex="-1" aria-hidden="true"><img src="${esc(p.image)}" alt="" loading="lazy" width="150" height="150"></a>${p.available && v.compare > v.price ? '<span class="yips-sale-tag" aria-hidden="true">BF Sale</span>' : ''}
            ${p.available ? `<button type="button" class="button yb__rail-add" data-yb-rail-add="${p.id}" aria-label="Add ${esc(p.title)} to your 3-pack">+</button>` : '<span class="yb__pill yb__pill--muted yb__card-tag">Sold out</span>'}</div>
          <a href="${esc(p.url)}">${esc(p.title)}</a><span class="yb__rail-price">${fmt(v.price)}</span>
        </div></li>`;
      }).join('');
    }
    if (el.rail) {
      renderRail();
      el.rail.addEventListener('click', (e) => {
        const b = e.target.closest('[data-yb-rail-add]'); if (!b) return;
        const p = byId.get(Number(b.dataset.ybRailAdd));
        if (state.mode !== 'bundle') setMode('bundle');
        const i = state.slots.findIndex((s) => !s);
        if (i < 0) { announce('Your 3-pack is full. Remove a hat to swap one in.'); $('[data-yb-pack]', root)?.scrollIntoView({ block: 'center' }); return; }
        if (colors(p).length > 1) { cardVariant.clear(); $('[data-yb-pack]', root)?.scrollIntoView({ block: 'center' }); openSheet(i, b); return; }
        const v = p.variants.find((x) => canAdd(x, i));
        if (!v) { announce(`${p.title} is not available in that quantity.`); return; }
        state.slots[i] = { pid: p.id, vid: v.id }; render();
        announce(`${p.title} added as hat ${i + 1 + cs.locked.length}. ${filled().length + cs.locked.length} of 3 picked.`);
      });
    }

    /* ---------- "Make it three": desktop arrows (row is a native horizontal scroller everywhere) ---------- */
    if (el.rail) {
      const nav = $('[data-yb-rail-nav]', root);
      const prev = $('[data-yb-rail-prev]', root), next = $('[data-yb-rail-next]', root);
      const step = () => {
        const li = el.rail.querySelector('li');
        const gap = parseFloat(getComputedStyle(el.rail).columnGap) || 0;
        const per = li ? li.getBoundingClientRect().width + gap : el.rail.clientWidth;
        return Math.max(per, Math.floor(el.rail.clientWidth / per) * per);
      };
      const sync = () => {
        const max = el.rail.scrollWidth - el.rail.clientWidth;
        if (nav) nav.hidden = max <= 2;
        if (prev) prev.disabled = el.rail.scrollLeft <= 2;
        if (next) next.disabled = el.rail.scrollLeft >= max - 2;
      };
      const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (prev) prev.addEventListener('click', () => el.rail.scrollBy({ left: -step(), behavior: smooth }));
      if (next) next.addEventListener('click', () => el.rail.scrollBy({ left: step(), behavior: smooth }));
      let rafR;
      el.rail.addEventListener('scroll', () => { cancelAnimationFrame(rafR); rafR = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(el.rail);
      sync();
    }

    /* ---------- add to cart ---------- */
    async function afterAdd(cart) {
      const count = cart?.item_count;
      applyCart(cart); // header = real cart.item_count; pack resets to the new cart state
      // Upcart auto-adds the free gifts a moment later: re-read the cart so the header count matches the drawer
      setTimeout(syncCart, 1500); setTimeout(syncCart, 4000);
      if (typeof count === 'number') {
        document.dispatchEvent(Object.assign(new Event('cart:update', { bubbles: true }), { detail: { resource: cart, sourceId: root.id, data: { source: 'yips-bundle-builder', itemCount: count } } }));
      }
      if (typeof window.upcartRefreshCart === 'function') {
        try { await window.upcartRefreshCart(); } catch (e) { /* ignore */ }
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        return true;
      }
      return false;
    }
    /* Upcart hijacks any form posting to /cart/add (it re-posts only the form's single id).
       With JS running we drop the action and handle the click ourselves; without JS the
       Liquid product form still posts the single hat normally. */
    if (el.form) { el.form.removeAttribute('action'); el.form.setAttribute('data-yb-js', ''); }
    el.atc?.removeAttribute('name');
    el.form?.addEventListener('submit', (e) => { e.preventDefault(); e.stopImmediatePropagation(); addToCart(); }, true);
    el.atc?.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); if (!el.atc.disabled) addToCart(); }, true);
    async function addToCart() {
      if (state.busy) return;
      showError('');
      let items;
      if (state.mode === 'single') {
        if (!currentVariant.available) return;
        items = [{ id: currentVariant.id, quantity: 1 }];
      } else {
        const f = filled();
        if (f.length < state.slots.length) { $(`[data-yb-slot="${state.slots.findIndex((s) => !s)}"]`, root)?.focus(); return; }
        const q = new Map(); f.forEach((x) => q.set(x.vid, (q.get(x.vid) || 0) + 1));
        items = [...q].map(([id, quantity]) => ({ id, quantity }));
      }
      state.busy = true; el.atc.setAttribute('aria-busy', 'true'); render();
      try {
        const res = await fetch(cfg.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
        const cart = await fetch(cfg.cartJsUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
        announce(state.mode === 'bundle' ? 'Bundle added to cart. Buy 2 Get 1 Free applies in cart.' : 'Added to cart.');
        const handled = await afterAdd(cart);
        if (!handled) window.location.href = cfg.cartUrl || '/cart';
      } catch (err) {
        showError(err.message);
      } finally {
        state.busy = false; el.atc.removeAttribute('aria-busy'); render();
      }
    }

    /* ---------- sticky bar ---------- */
    if (el.sticky && el.atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        el.sticky.classList.toggle('is-visible', show);
        el.sticky.setAttribute('aria-hidden', String(!show));
        el.stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(el.atc);
      el.stickyBtn.addEventListener('click', () => {
        if (state.mode === 'bundle' && filled().length < state.slots.length) {
          $('[data-yb-pack]', root)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => $(`[data-yb-slot="${state.slots.findIndex((s) => !s)}"]`, root)?.focus({ preventScroll: true }), 400);
          return;
        }
        addToCart();
      });
    }

    /* ---------- gallery ---------- */
    if (el.track) {
      const visDots = () => $$('[data-yb-dot]', root).filter((d) => !d.hidden);
      let raf;
      el.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(el.track.scrollLeft / Math.max(1, el.track.clientWidth));
          if (el.counter) el.counter.textContent = i + 1;
          visDots().forEach((d, j) => (j === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
        });
      }, { passive: true });
      $$('[data-yb-dot]', root).forEach((d) => d.addEventListener('click', () => {
        const j = visDots().indexOf(d);
        if (j >= 0) el.track.scrollTo({ left: j * el.track.clientWidth, behavior: 'smooth' });
      }));
      el.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); el.track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * el.track.clientWidth, behavior: 'smooth' }); }
      });
    }

    /* ---------- desktop: buy box sticks only when it fits the screen ---------- */
    {
      const info = $('.yb__info', root);
      const mq = matchMedia('(min-width: 990px)');
      const fit = () => { if (info) info.classList.toggle('yb__info--stick', mq.matches && info.offsetHeight + 48 <= window.innerHeight); };
      if (info) {
        fit();
        window.addEventListener('resize', fit, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(fit).observe(info);
      }
    }

    /* Klaviyo "10% OFF" teaser (app-injected, bottom-left): hide it while the bundle /
       add-to-cart area passes through the bottom band of the screen where it sits. */
    if ('IntersectionObserver' in window) {
      const zones = ['.yb__bundle-head', '.yb__tiles', '[data-yb-pack]', '.yb__gifts', '.yb__form', '[data-yb-stock]', '[data-yb-error]', '.yb__trust']
        .map((q) => $(q, root)).filter(Boolean);
      const hit = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => (en.isIntersecting ? hit.add(en.target) : hit.delete(en.target)));
        document.documentElement.classList.toggle('yb-teaser-hide', hit.size > 0);
      }, { rootMargin: '-62% 0px 0px 0px' });
      zones.forEach((z) => io.observe(z));
    }

    setMode(state.mode);
    if (currentVariant.id !== Number(el.input?.value)) setVariant(currentVariant.id);

    /* displayed unit price: initial read, Elevate late load / bucketing, external price rewrites */
    onDisplayedPrice(); refreshPrices();
    if (priceBox && 'MutationObserver' in window) {
      let qd = 0;
      new MutationObserver(() => { if (qd) return; qd = setTimeout(() => { qd = 0; onDisplayedPrice(); }, 0); })
        .observe(priceBox, { childList: true, subtree: true, characterData: true });
    }
    [300, 1000, 2500, 5000].forEach((ms) => setTimeout(() => refreshPrices(), ms));
    window.addEventListener('load', () => refreshPrices());
    document.addEventListener('yips:price-refresh', () => refreshPrices());
    try { if (window.cookieStore && cookieStore.addEventListener) cookieStore.addEventListener('change', (e) => { if ([...(e.changed || []), ...(e.deleted || [])].some((c) => /^AB(TL|AU)$/.test(c.name))) refreshPrices(); }); } catch (e) { /* ignore */ }
    root.yipsPrice = { refresh: () => refreshPrices(), unitPrice: () => currentVariant.price, source: () => priceSource, elevate: () => eabInfo };

    /* ---------- keep in sync with the cart (bundle builder on only) ---------- */
    if (cfg.inBundle) {
      syncCart();
      const CART_MUT = /\/cart\/(add|change|update|clear)(\.js)?$/;
      if ('PerformanceObserver' in window) {
        try {
          new PerformanceObserver((list) => {
            if (list.getEntries().some((e) => { try { return CART_MUT.test(new URL(e.name, location.href).pathname); } catch (x) { return false; } })) scheduleSync();
          }).observe({ type: 'resource', buffered: false });
        } catch (e) { /* ignore */ }
      }
      ['cart:update', 'cart:refresh', 'cart:change'].forEach((ev) => document.addEventListener(ev, (e) => { if (e?.detail?.data?.source !== 'yips-bundle-builder') scheduleSync(); }));
      window.addEventListener('pageshow', (e) => { if (e.persisted) syncCart(); });
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') scheduleSync(0); });
    }
  }

  const boot = () => $$('[data-yb]').forEach((r) => { if (!r.__yb) { r.__yb = true; init(r); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  // For Elevate / other apps: window.YipsBundle.refreshPrices() re-reads the displayed price + eab_data.
  window.YipsBundle = Object.assign(window.YipsBundle || {}, { refreshPrices: () => document.dispatchEvent(new Event('yips:price-refresh')) });
})();
